import React from "react";
import { Amount } from "@design-system/Amount/Amount";
import { AllocationTotals } from "./allocationHelpers";
import styles from "../EditAllocationDrawer.module.scss";

interface Props {
    readonly allocation: AllocationTotals;
}

export const AllocationSummaryRows: React.FC<Props> = ({ allocation }) => (
    <div className={styles.summaryArea}>
        {allocation.transactionItemsTotal > 0 && (
            <div className={styles.summaryRow}>
                <span className={styles.summaryLabel}>Transaction match</span>
                <span className={styles.summaryValue}>
                    <Amount amount={allocation.transactionItemsTotal} />
                </span>
            </div>
        )}
        <div className={styles.summaryRow}>
            <span className={styles.summaryLabel}>Allocated total</span>
            <span className={styles.summaryValue}>
                <Amount amount={allocation.allocatedTotal} />
            </span>
        </div>
        <div className={styles.summaryRow}>
            <span className={styles.summaryLabel}>Amount to be allocated</span>
            <span className={styles.summaryValue}>
                <Amount amount={allocation.amountToBeAllocated} />
            </span>
        </div>
        <div className={styles.summaryRow}>
            <span className={styles.summaryLabel}>Difference</span>
            <span className={styles.summaryValue}>
                <Amount amount={allocation.remainingAmount} />
            </span>
        </div>
    </div>
);
